import ManagerHome from "./home";
import ManagerQuote from "./quote";
import ManagerJob from "./job";
import ManagerClient from "./client";
import ManagerQA from "./qa";
import ManagerProject from "./project";
import ManagerVendor from "./vendor";
import ManagerUser from "./user";

import {
    LAYOUT_MANAGER_HOME,
    LAYOUT_MANAGER_JOB_ROOT,
    LAYOUT_MANAGER_QUOTE_ROOT,
    LAYOUT_MANAGER_CLIENT_ROOT,
    LAYOUT_MANAGER_PROJECT_ROOT,
    LAYOUT_MANAGER_VENDOR_ROOT,
    LAYOUT_MANAGER_USER_ROOT,
    LAYOUT_MANAGER_QA_ROOT,
} from "./navigation";
const routes = [
    {
        path: "/secure/index",
        component: ManagerHome,
        allowToOneOf: [
            "ROLE_MANAGER_ADMIN",
            "ROLE_MANAGER_PROJECT",
            "ROLE_MANAGER_CLIENT",
            "ROLE_MANAGER_VENDOR",
            "ROLE_MANAGER_FINANCE",
        ],
    },
    {
        path: LAYOUT_MANAGER_HOME,
        component: ManagerHome,
        allowToOneOf: [
            "ROLE_MANAGER_ADMIN",
            "ROLE_MANAGER_PROJECT",
            "ROLE_MANAGER_CLIENT",
            "ROLE_MANAGER_VENDOR",
            "ROLE_MANAGER_FINANCE",
        ],
    },
    {
        path: LAYOUT_MANAGER_USER_ROOT,
        component: ManagerUser,
        allowToOneOf: [
            "ROLE_MANAGER_ADMIN",
            "ROLE_MANAGER_PROJECT",
            "ROLE_MANAGER_CLIENT",
            "ROLE_MANAGER_VENDOR",
            "ROLE_MANAGER_FINANCE",
        ],
    },
    {
        path: LAYOUT_MANAGER_JOB_ROOT,
        component: ManagerJob,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_PROJECT"],
    },
    {
        path: LAYOUT_MANAGER_QUOTE_ROOT,
        component: ManagerQuote,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_PROJECT"],
    },
    {
        path: LAYOUT_MANAGER_PROJECT_ROOT,
        component: ManagerProject,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_CLIENT"],
    },
    {
        path: LAYOUT_MANAGER_CLIENT_ROOT,
        component: ManagerClient,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_CLIENT"],
    },
    {
        path: LAYOUT_MANAGER_VENDOR_ROOT,
        component: ManagerVendor,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_VENDOR"],
    },
    {
        path: LAYOUT_MANAGER_QA_ROOT,
        component: ManagerQA,
        allowToOneOf: ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_VENDOR"],
    },
];

export default routes;
